import { gql } from '@apollo/client';

export const COPY_MCP_MUTATION = gql`
  mutation CopyMcp($id: Int!) {
    mcp {
      copyMcp(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
